/*
* -----------------------------------------------------------------------------
* POPUP TRIGGER
* -----------------------------------------------------------------------------
* @version 0.0.3
* @kind component
* @overview Transitionable dialog state toggling.
* @copyright 2021 Cam Gould & Creiamo Pty Ltd (FKA Elkfox) - All rights reserved
* -----------------------------------------------------------------------------
*/

if (customElements.get("popup-trigger") === undefined) {
    class PopupTrigger extends HTMLElement {
        constructor() {
            super();
            this.trigger = this.querySelector("[aria-haspopup]");
            this.target = document.querySelector(this.attributes["data-target"].value);
            if (!this.target.toggle) return;
            this.toggleTarget = this.toggleTarget.bind(this);
            this.trigger.addEventListener("click", this.toggleTarget);
        }
        toggleTarget(event) {
            event.preventDefault();
            this.target.toggle();
        }
    }
    customElements.define("popup-trigger", PopupTrigger);
}